module.exports = __webpack_public_path__ + "static/media/checkAstroLogo.ad36188a.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/checkAstroLogo.png
// module id = 1513
// module chunks = 0